import { RouteType } from "../../../types/RouteType";

const TruckMaintenanceWorkflowRoute: RouteType = {
  name: "Truck Maintenance",
  path: "/workflows/truck-maintenance",
  layout: "/app",
  requiresAuth: true,
  viewportCard: {
    header: {
      component: () => import("./TruckMaintenanceWorkflowHeader"),
      title: "Record Truck Maintenance",
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./TruckMaintenanceWorkflow"),
      grayBackground: true,
    },
  },
  requiresPermission: false,
  beforeEnter: async () => {
    return true;
  },
};

export default TruckMaintenanceWorkflowRoute;
